<script>
	import Correct from "../icons/correct.svelte";
	import Thumb from "../icons/thumb.svelte";
	import { playSound, Sounds } from "../services/audio";
	import VoterList from "./VoterList.svelte";
	import Coins from "../icons/coins.svelte";

	export let isUserTurn = false;
	export let hasAnswered = false;
	export let leaderboardState = false;
	export let shuffledQuestionData = [];
	export let votedAnswer;
	export let questionData = {};
	export let lieUsers = [];
	export let truth1Users = [];
	export let truth2Users = [];
	export let onButtonClick = () => {};
	export let clickHandler = () => {};
	export let selectedAnswer;

	$: {
		if (leaderboardState === true && questionData?.info !== undefined) {
			if (!isUserTurn) {
				if (votedAnswer === questionData.info.lie) {
					playSound(Sounds.correct);
				} else playSound(Sounds.wrong);
			} else {
				if (lieUsers.length === 0) playSound(Sounds.correct);
				else playSound(Sounds.wrong);
			}
		}
	}
</script>

<div class="TruthLieWrapper">
	{#each Array(3) as _, i}
		<div
			class="dataContainer"
			on:click={() => clickHandler(shuffledQuestionData[i])}
			class:myturn={isUserTurn}
			class:canClick={!isUserTurn && !hasAnswered && !leaderboardState}
			class:disabled={(selectedAnswer !== undefined && selectedAnswer !== shuffledQuestionData[i]) ||
				(hasAnswered && votedAnswer !== shuffledQuestionData[i])}
			class:isSelected={selectedAnswer === shuffledQuestionData[i] || votedAnswer === shuffledQuestionData[i]}
			class:showAnswer={leaderboardState === true &&
				questionData?.info !== undefined &&
				shuffledQuestionData[i] === questionData.info.lie}
			class:disableCurrUser={leaderboardState === true &&
				questionData?.info !== undefined &&
				isUserTurn &&
				shuffledQuestionData[i] !== questionData.info.lie}
			class:disableUnanswered={leaderboardState === true &&
				votedAnswer === undefined &&
				questionData?.info !== undefined &&
				shuffledQuestionData[i] !== questionData.info.lie}
		>
			{#if (leaderboardState === true && questionData?.info !== undefined && votedAnswer === shuffledQuestionData[i] && shuffledQuestionData[i] === questionData.info.lie) || (leaderboardState === true && questionData?.info !== undefined && isUserTurn === true && lieUsers.length === 0 && shuffledQuestionData[i] === questionData.info.lie)}
				<div class="bubble-wrap">
					{#each [...Array(30)] as elem}
						<div class="bubble" />
					{/each}
				</div>
			{/if}

			{#if votedAnswer === shuffledQuestionData[i]}
				<div
					class="selectedAns"
					class:greenBorder={leaderboardState === true &&
						questionData?.info !== undefined &&
						shuffledQuestionData[i] === questionData.info.lie}
				>
					You Voted <Thumb />
				</div>
			{/if}
			{#if leaderboardState === true && questionData?.info !== undefined && shuffledQuestionData[i] === questionData.info.lie}
				<Correct />
			{/if}
			<div
				class="question"
				class:greenText={leaderboardState === true &&
					questionData?.info !== undefined &&
					shuffledQuestionData[i] === questionData.info.lie}
			>
				{shuffledQuestionData[i]}
			</div>
			{#if !isUserTurn}
				{#if selectedAnswer === shuffledQuestionData[i] && !hasAnswered && !leaderboardState}
					<button
						on:click={() => {
							onButtonClick(shuffledQuestionData[i]);
							selectedAnswer = undefined;
						}}
						class="voteButton">SUBMIT</button
					>
				{/if}
			{/if}
			{#if leaderboardState && questionData?.info !== undefined}
				<VoterList
					votersArray={shuffledQuestionData[i] === questionData.info.lie
						? lieUsers
						: shuffledQuestionData[i] === questionData.info.truth1
						? truth1Users
						: truth2Users}
				/>
			{/if}
		</div>
	{/each}
</div>

<div>
	{#if leaderboardState === true && questionData?.info !== undefined && votedAnswer === questionData.info.lie}
		<div class="coinDiv">
			<Coins /> +25
		</div>
	{/if}
	{#if leaderboardState === true && isUserTurn === true && lieUsers.length === 0 && truth1Users.length + truth2Users.length !== 0}
		<div class="coinDiv">
			<Coins /> +50
		</div>
	{/if}
</div>

<style lang="scss">
	@keyframes coinAnimation {
		0% {
			transform: translatex(0px) translatey(0px);
			opacity: 1;
		}
		80% {
			opacity: 0.8;
		}

		100% {
			transform: translatex(-10vw) translatey(-80vh);
			opacity: 0;
		}
	}

	.coinDiv {
		position: absolute;
		display: flex;
		flex-direction: row;
		justify-content: center;
		align-items: center;
		animation: coinAnimation 2s;
		opacity: 0;
	}

	.TruthLieWrapper {
		display: inline-flex;
		flex-wrap: wrap;
		flex-direction: row;
		gap: 1.5rem;
	}

	.dataContainer {
		display: inline-flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		padding: 2rem;
		flex-wrap: wrap;
		gap: 1rem;
		position: relative;

		background: #ffffff;
		font-family: Poppins;
		font-style: normal;
		font-weight: bold;
		font-size: 0.9rem;
		line-height: 1.2rem;
		text-align: center;
		color: #373637;
		border: 3px solid #373637;
		box-shadow: -8px 8px 0px rgba(0, 0, 0, 0.25);
		border-radius: 12px;
		font-weight: bolder;
		min-height: 35vh;
		max-height: 35vh;
		min-width: 20vw;
		max-width: 20vw;
	}

	.question {
		word-wrap: break-word;
		hyphens: auto;
		overflow-y: scroll;
		overflow-x: hidden;
		display: -webkit-box;
		-webkit-box-orient: vertical;
	}

	::-webkit-scrollbar {
		width: 1px;
	}

	.disabled,
	.disableCurrUser,
	.myturn,
	.disableUnanswered {
		opacity: 0.5;
	}

	.canClick {
		transition: transform 0.1s;
	}

	.canClick:hover {
		transform: scale(1.05);
		cursor: url("data:image/svg+xml,%3Csvg width='66' height='27' viewBox='0 0 66 27' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M58.7065 16.947C59.2571 20.576 56.7616 23.964 53.1326 24.5145C49.5037 25.065 46.1157 22.5694 45.5652 18.9406L45.0891 15.8017C44.5386 12.1728 47.034 8.78469 50.663 8.23418C54.2919 7.68368 57.68 10.1792 58.2305 13.8081L58.7066 16.947L58.7065 16.947Z' fill='%23F0D3A3'/%3E%3Cpath opacity='0.05' d='M51.1499 23.3574C51.1087 23.3637 51.0658 23.3628 51.0225 23.3539C49.8954 23.119 48.8427 22.5215 48.0584 21.6713C47.9237 21.5252 47.9329 21.2975 48.0789 21.1627C48.2251 21.028 48.4528 21.0372 48.5875 21.1832C49.2709 21.9241 50.1879 22.4447 51.1694 22.6493C51.3639 22.6898 51.4888 22.8804 51.4483 23.075C51.4168 23.2264 51.2944 23.3355 51.1499 23.3574Z' fill='black'/%3E%3Cpath opacity='0.05' d='M48.1507 19.1985C47.9651 19.2267 47.7869 19.1064 47.7457 18.9205C47.7235 18.8209 47.7046 18.7192 47.6893 18.6183C47.6595 18.4218 47.7947 18.2383 47.9912 18.2085C48.1876 18.1787 48.3711 18.3138 48.4009 18.5104C48.4138 18.5953 48.4298 18.6809 48.4484 18.7648C48.4914 18.9588 48.369 19.151 48.1749 19.194C48.1669 19.1958 48.1588 19.1973 48.1507 19.1985Z' fill='black'/%3E%3Cpath opacity='0.05' d='M49.3836 21.338C49.2793 21.3538 49.1691 21.3239 49.0855 21.2468C48.6673 20.8613 48.3305 20.4076 48.0845 19.8984C47.998 19.7194 48.0731 19.5042 48.252 19.4178C48.4311 19.3314 48.6462 19.4063 48.7327 19.5853C48.9392 20.0127 49.222 20.3938 49.5733 20.7176C49.7194 20.8523 49.7287 21.08 49.594 21.2262C49.5363 21.2887 49.4616 21.3262 49.3836 21.338Z' fill='black'/%3E%3Cpath opacity='0.05' d='M53.7239 23.9109C50.095 24.4614 46.7069 21.9659 46.1564 18.337L45.6802 15.1981C45.3772 13.2007 45.9973 11.2765 47.2209 9.85807C45.6131 11.3035 44.7405 13.504 45.089 15.8013L45.5652 18.9402C46.1157 22.5691 49.5037 25.0646 53.1327 24.5141C54.7642 24.2666 56.1664 23.4454 57.1659 22.2867C56.2341 23.1245 55.0555 23.7089 53.7239 23.9109Z' fill='black'/%3E%3Cpath d='M47.0913 17.4527L46.0754 17.6068C45.559 17.6851 45.0769 17.33 44.9985 16.8135L44.4055 12.9045L46.3564 12.6086L47.0913 17.4527Z' fill='%23272F37'/%3E%3Cpath d='M47.3815 17.4086C47.2213 17.4329 47.0718 17.3227 47.0475 17.1626L46.3567 12.6086L48.4872 12.2854L48.9428 15.289C49.0971 16.3054 48.398 17.2544 47.3815 17.4086Z' fill='%23272F37'/%3E%3Cpath d='M62.6997 11.2697C62.8432 12.2154 62.2866 13.1221 62.0494 13.4577C61.9939 13.5361 61.8852 13.5526 61.809 13.4941C61.483 13.244 60.6825 12.5432 60.539 11.5974C60.3955 10.6517 60.9521 9.74502 61.1893 9.40945C61.2448 9.33104 61.3535 9.31454 61.4297 9.37298C61.7558 9.62306 62.5562 10.3239 62.6997 11.2697Z' fill='%2300A155'/%3E%3Cpath d='M63.5534 17.0279C64.1944 16.9307 64.6353 16.3321 64.5381 15.691C64.4408 15.05 63.8423 14.6091 63.2012 14.7063L55.2345 15.9149C54.5935 16.0121 54.1526 16.6106 54.2498 17.2517C54.3471 17.8928 54.9456 18.3337 55.5867 18.2364L63.5534 17.0279Z' fill='%23C39774'/%3E%3Cpath opacity='0.05' d='M56.706 17.0368L55.5487 17.2124C55.3521 17.2422 55.1687 17.107 55.1389 16.9105C55.1091 16.7139 55.2442 16.5305 55.4407 16.5007L56.598 16.3251C56.7946 16.2953 56.978 16.4304 57.0078 16.627C57.0376 16.8235 56.9025 17.007 56.706 17.0368Z' fill='black'/%3E%3Cpath opacity='0.05' d='M61.1301 16.7462L58.6253 17.1261C58.4287 17.156 58.2453 17.0208 58.2155 16.8243C58.1857 16.6277 58.3208 16.4443 58.5174 16.4144L61.0221 16.0345C61.2187 16.0046 61.4021 16.1398 61.4319 16.3363C61.4617 16.5329 61.3267 16.7163 61.1301 16.7462Z' fill='black'/%3E%3Cpath d='M53.0269 19.3166C52.7595 19.3572 52.5942 19.6309 52.6835 19.8861C53.1115 21.1095 54.3617 21.8946 55.6899 21.6931C57.0181 21.4916 57.9793 20.3711 58.0252 19.0758C58.0348 18.8055 57.7957 18.5932 57.5284 18.6338L53.0269 19.3166Z' fill='%23C39774'/%3E%3Cpath opacity='0.1' d='M53.9883 20.3834C53.6711 20.4315 53.3689 20.5168 53.0842 20.6326C53.6729 21.4102 54.6577 21.8495 55.6898 21.6929C56.1765 21.6191 56.6136 21.4214 56.9748 21.1375C56.1507 20.5178 55.0882 20.2165 53.9883 20.3834Z' fill='black'/%3E%3Cpath d='M46.7683 15.3229C46.7418 15.1484 46.5682 15.0341 46.3985 15.0828C45.1857 15.4302 44.3903 16.6325 44.5846 17.9132C44.7788 19.1937 45.895 20.1062 47.1563 20.0783C47.3328 20.0743 47.4647 19.9138 47.4382 19.7393L46.7683 15.3229Z' fill='%23C39774'/%3E%3Cpath opacity='0.2' d='M50.6631 8.23421C48.0885 8.62478 46.0848 10.4438 45.3342 12.7637L44.4054 12.9046L44.7204 14.981L58.045 12.9597C57.136 9.79944 54.0016 7.72777 50.6631 8.23421Z' fill='black'/%3E%3Cpath d='M58.3121 12.388L44.6155 14.4657C43.9293 14.5698 43.3844 13.8976 43.6282 13.2478C44.7255 10.3226 44.6595 7.08798 43.4438 4.20993C43.2043 3.64283 43.7081 3.04307 44.308 3.18116L48.4388 4.13205C52.6223 5.09509 56.3296 7.50858 58.9033 10.9445C59.3152 11.4944 58.9914 12.2849 58.3121 12.388Z' fill='%23DE2A4E'/%3E%3Cpath opacity='0.1' d='M44.7249 13.4959C45.7758 10.1914 45.5198 6.60982 44.0096 3.48841C43.962 3.39008 43.9357 3.28973 43.9273 3.19099C43.5202 3.31019 43.2581 3.76984 43.444 4.21003C44.6598 7.08807 44.7258 10.3228 43.6284 13.248C43.3846 13.8978 43.9295 14.5699 44.6156 14.4658L44.8923 14.4239C44.6977 14.1763 44.616 13.8383 44.7249 13.4959ZM55.7213 12.7812L58.3124 12.3881C58.5067 12.3587 58.6718 12.2727 58.7991 12.1525L55.7213 12.7812Z' fill='black'/%3E%3Cpath d='M44.4119 7.28332C45.8523 8.34426 46.6855 9.85759 47.0913 10.7837C47.2618 11.1729 46.9468 11.6005 46.5246 11.553C45.5198 11.4401 43.8274 11.0933 42.3871 10.0323C42.3476 10.0032 42.3086 9.97383 42.27 9.94409C40.5261 8.59955 42.4917 5.93098 44.2929 7.19766C44.3327 7.2257 44.3724 7.25421 44.4119 7.28332Z' fill='%23FDD05F'/%3E%3Cpath opacity='0.15' d='M45.1583 10.2695C45.0673 10.2833 44.9709 10.2623 44.8909 10.2034L43.231 8.98077C43.071 8.8629 43.0368 8.63757 43.1547 8.47759C43.2725 8.31757 43.4979 8.28338 43.6578 8.40126L45.3177 9.62387C45.4777 9.74174 45.5119 9.96706 45.394 10.127C45.3351 10.2071 45.2493 10.2556 45.1583 10.2695Z' fill='black'/%3E%3Cpath d='M63.1475 14.3508L61.6581 14.5767L62.2645 13.7534C62.2938 13.7272 62.3206 13.6979 62.3435 13.6655C62.6118 13.2859 63.2183 12.2873 63.0557 11.2158C62.8932 10.1443 62.0178 9.37052 61.6491 9.08756C61.5355 9.00039 61.3894 8.96274 61.248 8.98418C61.1067 9.00562 60.9782 9.08493 60.8957 9.20185C60.6274 9.58149 60.0209 10.5801 60.1834 11.6515C60.3268 12.5964 61.0242 13.3095 61.4401 13.6589L60.6516 14.7294L58.7772 15.0137L58.5862 13.7543C58.5344 13.413 58.4568 13.0753 58.3558 12.7456L58.3661 12.744C58.8115 12.6765 59.1792 12.3873 59.35 11.9704C59.5207 11.5535 59.4614 11.0894 59.1913 10.7289C56.5701 7.2296 52.7802 4.76232 48.5195 3.78153L44.3888 2.83059C43.9787 2.73622 43.5561 2.8777 43.2856 3.19977C43.015 3.52186 42.9486 3.96262 43.1123 4.35013C43.4143 5.06515 43.6451 5.80995 43.8017 6.57181C42.9501 6.34625 42.1303 6.74309 41.6624 7.37839C41.0667 8.18714 41.0086 9.4261 42.0504 10.2293C42.091 10.2605 42.1321 10.2915 42.1738 10.3222C42.7059 10.7142 43.2681 11.0136 43.8239 11.2427C43.6984 11.8818 43.5197 12.5125 43.2912 13.1216C43.1314 13.5476 43.2071 14.0129 43.4936 14.3663C43.7078 14.6304 44.0075 14.7922 44.3331 14.8285L44.5364 16.1687C44.2519 16.7042 44.1318 17.3304 44.2284 17.9668C44.3493 18.764 44.79 19.4448 45.4056 19.889C46.3757 23.2641 49.6963 25.3999 53.1866 24.8704C56.5802 24.3556 59.0891 21.4583 59.1412 18.0615L63.6077 17.384C64.4439 17.2571 65.0211 16.4735 64.8942 15.6373C64.7673 14.801 63.9837 14.2239 63.1475 14.3508ZM60.8951 11.5436C60.7903 10.8526 61.1314 10.1672 61.3699 9.78777C61.7102 10.0794 62.2393 10.6328 62.3441 11.3237C62.4489 12.0147 62.1078 12.7001 61.8693 13.0795C61.529 12.7879 60.9999 12.2345 60.8951 11.5436ZM42.6008 9.74284C42.5634 9.71522 42.5264 9.68734 42.4898 9.65922C41.779 9.11112 41.8531 8.33316 42.2419 7.80528C42.4959 7.46052 42.8019 7.28853 43.1101 7.24179C43.4567 7.1892 43.8059 7.29523 44.0861 7.49222C44.1237 7.51876 44.1613 7.54572 44.1986 7.57323C45.6028 8.60754 46.4072 10.1193 46.7618 10.9283C46.8019 11.0199 46.7603 11.092 46.7406 11.1188C46.7209 11.1456 46.6644 11.2067 46.565 11.1955C45.6871 11.0969 44.0049 10.777 42.6008 9.74284ZM44.0527 13.913C43.9287 13.7601 43.896 13.5588 43.9651 13.3744C44.1943 12.7636 44.3754 12.1321 44.5072 11.4921C45.2334 11.7247 45.9215 11.8475 46.4846 11.9109C46.567 11.9201 46.6485 11.9184 46.7274 11.9065C46.9621 11.8709 47.1738 11.7444 47.3202 11.5457C47.5157 11.2803 47.5535 10.9415 47.4211 10.6395C46.9527 9.57071 46.0876 8.07064 44.6255 6.99371C44.6197 6.98946 44.6138 6.9854 44.608 6.98111C44.4483 5.97981 44.1687 5.00123 43.7753 4.07002C43.7165 3.93075 43.7394 3.77849 43.8367 3.66272C43.9339 3.54691 44.0799 3.49811 44.2272 3.53202L48.358 4.48286C52.453 5.42556 56.0958 7.79698 58.6151 11.1604C58.7338 11.3187 58.7588 11.5145 58.6838 11.6976C58.6088 11.8807 58.4537 12.0026 58.2581 12.0323L44.5615 14.11C44.3668 14.1396 44.1767 14.0659 44.0527 13.913ZM46.8291 14.8149C46.6716 14.7138 46.4783 14.6851 46.2989 14.7366C45.8572 14.8631 45.4664 15.0883 45.145 15.3823L45.0512 14.7638L48.421 14.2526L48.5864 15.343C48.7072 16.1396 48.1754 16.8871 47.3925 17.0413L47.1236 15.2688C47.0953 15.0822 46.988 14.9168 46.8291 14.8149ZM44.9399 17.859C44.7793 16.8004 45.4137 15.7793 46.4232 15.4511L46.5249 16.1218C45.8901 16.3822 45.4895 17.0516 45.5968 17.7593C45.7042 18.4671 46.2854 18.9876 46.9688 19.0479L47.0706 19.7186C46.0092 19.7045 45.1005 18.9175 44.9399 17.859ZM46.6393 16.8758L46.8545 18.2939C46.5751 18.2024 46.3555 17.9612 46.3085 17.6513C46.2615 17.3414 46.3997 17.046 46.6393 16.8758ZM53.0786 24.1588C50.1739 24.5994 47.4004 22.983 46.3191 20.3304C46.5884 20.4062 46.8721 20.4444 47.1638 20.4379C47.1916 20.4373 47.2193 20.4349 47.2465 20.4308C47.4017 20.4072 47.5445 20.3278 47.647 20.2059C47.7684 20.0614 47.8218 19.8716 47.7936 19.6851L47.5005 17.753C48.6759 17.5389 49.4784 16.4241 49.298 15.2351L49.1326 14.1447L57.6356 12.8548C57.7017 13.0585 57.7576 13.2658 57.8029 13.4755C57.5192 13.3425 57.1948 13.289 56.8626 13.3394C55.9675 13.4751 55.3498 14.3138 55.4856 15.2088C55.5045 15.3333 55.5851 15.4329 55.6915 15.4819L55.1809 15.5594C54.3446 15.6862 53.7675 16.4698 53.8943 17.306C54.0042 18.0303 54.6067 18.5598 55.3093 18.6063L52.9726 18.9608C52.7387 18.9963 52.5346 19.1329 52.4126 19.3357C52.2907 19.5382 52.2655 19.7821 52.3435 20.005C52.8363 21.4134 54.2662 22.273 55.7437 22.0489C56.4928 21.9353 57.1473 21.5588 57.6178 21.0211C56.6957 22.6591 55.0544 23.859 53.0786 24.1588ZM58.0204 14.8242L58.0655 15.1217L56.0816 15.4227C56.1687 15.3444 56.2162 15.2253 56.1973 15.1008C56.1211 14.5982 56.4679 14.1272 56.9706 14.051C57.4732 13.9747 57.9442 14.3216 58.0204 14.8242ZM57.6653 19.063C57.6246 20.2085 56.7711 21.165 55.6357 21.3372C54.5003 21.5094 53.4014 20.8492 53.0229 19.7672C53.0138 19.7411 53.0213 19.72 53.0292 19.7068C53.0373 19.6935 53.0527 19.6767 53.0805 19.6724L57.5821 18.9895C57.6099 18.9853 57.6296 18.9968 57.6413 19.0072C57.6528 19.0174 57.6662 19.0354 57.6653 19.063ZM58.3569 18.8541C58.3174 18.7074 58.2367 18.5735 58.1202 18.4698C58.0036 18.366 57.8613 18.3011 57.7109 18.2785L58.4183 18.1712C58.4102 18.4018 58.3896 18.6297 58.3569 18.8541ZM63.4997 16.6723L55.533 17.8809C55.0892 17.9482 54.6733 17.6419 54.606 17.198C54.5387 16.7542 54.8449 16.3383 55.2888 16.271L63.2554 15.0625C63.6992 14.9951 64.1151 15.3014 64.1825 15.7453C64.2498 16.1891 63.9435 16.605 63.4997 16.6723ZM62.0458 11.8438L61.905 10.9155C61.8752 10.719 61.6918 10.5839 61.4952 10.6137C61.2986 10.6435 61.1635 10.827 61.1933 11.0235L61.3341 11.9518C61.3639 12.1483 61.5474 12.2834 61.744 12.2536C61.9405 12.2238 62.0757 12.0403 62.0458 11.8438ZM52.7829 15.6188C52.8128 15.8153 52.9962 15.9505 53.1927 15.9206C53.3892 15.8908 53.5244 15.7073 53.4946 15.5108C53.3588 14.6158 52.5202 13.9981 51.6251 14.1338C50.7301 14.2696 50.1124 15.1083 50.2482 16.0033C50.278 16.1998 50.4615 16.335 50.658 16.3052C50.8545 16.2754 50.9896 16.0919 50.9598 15.8953C50.8836 15.3927 51.2305 14.9217 51.7331 14.8455C52.2358 14.7692 52.7067 15.1161 52.7829 15.6188Z' fill='black'/%3E%3Cpath d='M13.7553 25.2622L13.7626 25.2626L13.7699 25.2629C14.3233 25.2842 14.8827 25.1484 15.2962 24.727C15.7013 24.314 15.8336 23.7609 15.8336 23.2308V21.3163C15.8336 20.7706 15.701 20.2209 15.2757 19.8117C14.8688 19.4201 14.3295 19.2915 13.8293 19.2545L13.8293 19.2543L13.8152 19.2535L7.35954 18.8887V4.71339C7.35954 4.17274 7.22963 3.61297 6.81276 3.19611C6.3959 2.77924 5.83613 2.64933 5.29548 2.64933H3.25542C2.71477 2.64933 2.155 2.77924 1.73813 3.19611C1.32127 3.61297 1.19136 4.17274 1.19136 4.71339V22.6345C1.19136 23.1748 1.32137 23.7353 1.74923 24.147C2.16423 24.5463 2.71302 24.6636 3.23111 24.6671L13.7553 25.2622ZM36.8905 16.6306L36.897 16.6301C37.3873 16.5924 37.9141 16.4612 38.3135 16.0772C38.7308 15.6759 38.8676 15.1379 38.8676 14.5998V12.6853C38.8676 12.1493 38.7401 11.5794 38.3313 11.1552C37.9069 10.7147 37.3262 10.5811 36.7475 10.6232C36.7463 10.6233 36.745 10.6234 36.7438 10.6235L30.9615 11.0035L31.0531 8.66058H38.0904C38.623 8.66058 39.1711 8.52687 39.5802 8.11773C39.9893 7.70859 40.1231 7.16057 40.1231 6.62791V4.71339C40.1231 4.17274 39.9931 3.61297 39.5763 3.1961C39.1594 2.77924 38.5996 2.64933 38.059 2.64933H27.231C26.6879 2.64933 26.1331 2.78057 25.7201 3.20158C25.3157 3.61368 25.1868 4.16296 25.1675 4.68346L25.1674 4.68599L24.5398 23.2009C24.5398 23.2013 24.5397 23.2018 24.5397 23.2022C24.5192 23.7623 24.6507 24.3325 25.0796 24.7534C25.5002 25.1662 26.065 25.2949 26.6033 25.2949H38.0904C38.623 25.2949 39.1711 25.1612 39.5802 24.752C39.9893 24.3429 40.1231 23.7949 40.1231 23.2622V21.3477C40.1231 20.8071 39.9931 20.2473 39.5763 19.8304C39.1594 19.4136 38.5996 19.2836 38.059 19.2836H30.6787L30.771 17.0517L36.8905 16.6306ZM22.7151 23.8585V4.08568C22.7151 3.54504 22.5852 2.98526 22.1684 2.5684C21.7515 2.15153 21.1917 2.02162 20.6511 2.02162H18.611C18.0704 2.02162 17.5106 2.15153 17.0937 2.56839C16.6769 2.98526 16.547 3.54503 16.547 4.08568V23.8585C16.547 24.3992 16.6769 24.959 17.0937 25.3758C17.5106 25.7927 18.0704 25.9226 18.611 25.9226H20.6511C21.1917 25.9226 21.7515 25.7927 22.1684 25.3758C22.5852 24.959 22.7151 24.3992 22.7151 23.8585Z' fill='%23E7435E' stroke='black' stroke-width='1.61729'/%3E%3C/svg%3E%0A")
				16 16,
			pointer;
	}

	.voteButton {
		display: flex;
		flex-direction: row;
		justify-content: center;
		align-items: center;
		padding: 0.3rem 0rem;

		cursor: pointer;
		width: 10rem;
		height: 2rem;

		/* Game/Orange */
		background: #e78843;
		color: whitesmoke;
		border: 2px solid #ffffff;
		box-shadow: 0px 4px 0px #f6ede4;
		border-radius: 6px;
	}

	.isSelected {
		border: 3px solid #e78843;
		transform: scale(1.05);
		transition: transform 0.1s;
	}

	.selectedAns {
		display: inline-flex;
		flex-direction: row;
		align-items: center;
		padding: 0.1rem 0.5rem;
		position: absolute;
		font-weight: bold;
		font-size: 14px;
		line-height: 21px;
		background: #f7f7f7;
		border: 2px solid #e78843;
		border-radius: 0.5rem;
		flex-wrap: wrap;
		gap: 0.5rem;
		top: 0;
		left: 50%;
		transform: translate(-50%, -50%);
	}

	.greenBorder {
		border: 2px solid #55b185;
	}

	.showAnswer {
		opacity: 1;
		border: 3.25087px solid #55b185;
		transform: scale(1.05);
		transition: transform 0.1s;
	}

	.greenText {
		color: #55b185;
	}

	@function randomNum($min, $max) {
		$rand: random();
		$randomNum: $min + floor($rand * (($max - $min) + 1));
		@return $randomNum;
	}

	.bubble-wrap {
		z-index: -100;
		margin: 0 auto;
		position: absolute;
		display: flex;
		align-items: center;
		justify-content: center;
		height: 100%;
		width: 100%;
		transform-style: preserve-3d;
		transform-origin: center center;
		animation: faded 0s ease-in 5s forwards;
		perspective: 300px;
	}
	.bubble {
		position: absolute;
		opacity: 0.7;
		z-index: -1;
		box-shadow: 0 20px 30px rgba(0, 0, 0, 0.2), inset 0px 10px 30px 5px rgba(255, 255, 255, 1);
		border-radius: 50%;
		animation: move 5s ease-in-out reverse;
	}
	@for $i from 1 through 30 {
		.bubble:nth-child(#{$i}) {
			$size: random(50) + px;
			height: $size;
			width: $size;
			animation-delay: -$i * 0.1s;
			transform: translate3d(#{randomNum(-1000, 1000)}px, #{randomNum(-1000, 1000)}px, 0);
			background: rgba(156, 86, 86, 0.575);
		}
	}

	@keyframes move {
		100% {
			transform: translate3d(0, 0, 0);
		}
	}

	@keyframes faded {
		to {
			width: 0;
			height: 0;
			overflow: hidden;
			opacity: 0;
		}
	}

	@media screen and (max-height: 800px) and (orientation: landscape) {
		.dataContainer {
			max-width: 30vw;
			min-width: 30vw;
			padding: 1rem;
			font-size: 1rem;
			line-height: 1.2rem;
		}
	}

	@media screen and (max-height: 650px) and (orientation: landscape) {
		.dataContainer {
			font-size: 0.8rem;
			line-height: 1rem;
		}
	}

	@media screen and (max-width: 319px) {
		.TruthLieWrapper {
			flex-direction: column;
		}
		.dataContainer {
			max-width: 90vw;
		}
	}
</style>
